module.exports = __webpack_public_path__ + "media/images/themes/deep_space/main_bg-2f7534b56a473d3cc1f13055f9d43644.png";